import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { Text } from '../topography'
import check_orange from '../../styles/assets/pricing/check_orange.svg'
import upgrade_icon from '../../styles/assets/upgrade_icon.svg'
import { PrimaryButton } from '../buttons/Buttons'
import Icon from '../icon/Icon'
import {
  KISSMETRICS_TRACK_EVENTS,
  kissmetricsRecordingEvent,
  PROPERTY_NAMES,
} from '../../utils/kissmetrics'
import { isFreeTrialUsed } from '../../utils/freeVersionBlock'
import { MIXPANEL_PROPS } from '../../utils/mixpanel'
import { checkoutModalHandler } from '../../utils/sendMessage'

const CTAWrapper = styled.div(() => ({
  margin: '12px',
  marginTop: '48px',
  padding: '16px',
  paddingTop: '41px',
  border: `1px solid ${palette.lightGray}`,
  backgroundColor: palette.lightGray10,
  position: 'relative',
}))

const List = styled.ul({
  padding: 0,
  width: '100%',
  margin: 0,
  listStyle: 'none',
})

const Item = styled.li({
  margin: '12px 0 ',
  fontSize: '14px',
  fontFamily: fonts.primaryLight,
  color: palette.darkGray,
  backgroundImage: `url('${check_orange}')`,
  backgroundRepeat: 'no-repeat',
  paddingLeft: '30px',
})

const bullets1 = ['pay_nothing_today', 'cancel_anytime', 'zero_risk_free_trial']
const bullets2 = [
  'upgrade_banner_bullet_one',
  'upgrade_banner_bullet_two',
  'upgrade_banner_bullet_three',
]
const UpgradeIconWrapper = styled.div({
  position: 'absolute',
  top: '-30px',
  left: 'calc(50% - 31px)',
  width: '60px',
  height: '30px',
  borderTopLeftRadius: '31px',
  borderTopRightRadius: '31px',
  border: `1px solid ${palette.lightGray}`,
  borderBottom: 0,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: palette.lightGray10,
})

const UpgradeIcon = styled.div({
  marginTop: '30px',
  backgroundColor: palette.white,
  width: '50px',
  height: '50px',
  borderRadius: '25px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.07)',
})

const StartFreeTrialCTA = () => {
  const trialUsed = isFreeTrialUsed()
  const bullets = trialUsed ? bullets2 : bullets1
  return (
    <CTAWrapper data-testid="proposal">
      <UpgradeIconWrapper>
        <UpgradeIcon>
          <Icon src={upgrade_icon} />
        </UpgradeIcon>
      </UpgradeIconWrapper>

      <Text fontSize="16px" fontFamily={fonts.primaryMedium}>
        {trialUsed
          ? translate('upgrade_banner_heading')
          : translate('start_free_trial_to_unlock', 7)}
      </Text>
      <List>
        {bullets.map((text, index) => (
          <Item key={`bullet_${index}`}>
            <Text fontFamily={fonts.primary} color={palette.darkGray50}>
              {translate(text)}
            </Text>
          </Item>
        ))}
      </List>
      <PrimaryButton
        theme="orange"
        tag={trialUsed ? translate('upgrade') : translate('get_started')}
        width="100%"
        mobileWidth="100%"
        style={{
          marginTop: '8px',
          minHeight: '36px',
          lineHeight: '14px',
          boxShadow: '0px 4px 8px 0px rgba(241, 100, 52, 0.3)',
        }}
        onClick={() => {
          checkoutModalHandler({
            mixpanelProps: [
              MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.NAVIGATION_SIDEBAR,
              trialUsed
                ? MIXPANEL_PROPS.BUTTON_CTA.values.UPGRADE
                : MIXPANEL_PROPS.BUTTON_CTA.values.START_TRIAL,
            ],
          })

          kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.clicked_upgrade, {
            [PROPERTY_NAMES.btn_location]: 'sidebar widget',
          })
        }}
      />
    </CTAWrapper>
  )
}

export default StartFreeTrialCTA
